export default class MessageEvent<T> extends Event {
  static readonly MESSAGE = "message";
  message: T;
  constructor(message: T) {
    super(MessageEvent.MESSAGE);
    this.message = message;
  }
}
